// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"eab65b20","498":"5bef6b71","511":"bd3d121d","598":"fad42168"}[chunkId] + ".chunk.js";
};